(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  var top_banner_carousel = jQuery('.top-banner-carousel');
  if(top_banner_carousel.length > 0 ) {
    top_banner_carousel.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      vertical: true
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-header"]) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(cartProductRecommendations);

      const url = cartProductRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          cartProductRecommendations.innerHTML = recommendations.innerHTML;
        }

        cartProductRecommendations.querySelectorAll('.cart-item button[data-bs-toggle]').forEach(item => {
          item.addEventListener('click', event => {
            event.preventDefault();
          })
        });

      })
      .catch(e => {
        console.error(e);
      });

    };

    const cartProductRecommendations = document.querySelector('.cart-product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(cartProductRecommendations);

    Shopify.runPromotions();

    jQuery('section.cart .order-list [quantity-select]').each(function( index ) {

      if(jQuery(this).next().length == 0) jQuery(this).inputSpinner();

      jQuery(this).on("change", function (event) {
        var variant_id = jQuery(this).closest('[quantity-select]').data('variant-id');
        var item_price = jQuery(this).closest('[quantity-select]').data('variant-price');
        var item_original_price = jQuery(this).closest('[quantity-select]').data('variant-original-price');
        var qty = jQuery(this).val();
        var target_ele = jQuery(this);
        var parent_ele =jQuery(this).parent().parent().parent();

        Shopify.changeItem( variant_id, qty, function() {
          /* update line item price */
          parent_ele.find('[item-price]').html( Shopify.formatMoney( (item_price*qty) ));
          if( item_original_price > item_price)
            parent_ele.find('[item-original-price]').html( Shopify.formatMoney( (item_original_price*qty) ));
        });
      });
    });

    /* Click Add-to-Cart on item */
    jQuery('[remove-from-cart]').on('click', function (evt) {
      // if variant ID passed, use that
      evt.preventDefault();
      Shopify.removeItem( jQuery(this).data('variant-id') );
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    

  var product_grid = jQuery('.collection .product-grid');
  product_grid.each(function() {

    var items_to_show = parseInt(jQuery(this).data('list-limit')); // index starts at zero
    var total_items = jQuery(this).find('> div').length;
    var view_more_button = jQuery(this).parent().find('.view-more-button:not([href])');

    if( items_to_show < total_items && view_more_button.length > 1 ) {
      items_to_show = items_to_show - 1;
      view_more_button.show();
      jQuery(this).find('> div:gt('+items_to_show+')').hide();
      jQuery(this).show();
      
      view_more_button.click(function () {
        var list_target = '[data-list-id="'+jQuery(this).data('list-id')+'"]';
        jQuery(list_target+' div').show();
        jQuery(this).hide();
      });
    }

  });

  var collection_carousel = jQuery('.collection.carousel .product-grid');
  var carousel_display = collection_carousel.data('slider-display');
  if(collection_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      collection_carousel.not('.slick-initialized').slick({
        slidesToShow: collection_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: collection_carousel.data('slider-arrows'),
        dots: collection_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  var product_grid_carousel = jQuery('.product-grid.carousel .row');
  var product_grid_display = product_grid_carousel.data('slider-display');
  if(product_grid_carousel.length > 0 ) {
    if(product_grid_display == 'all' || ( product_grid_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      product_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: product_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: product_grid_carousel.data('slider-arrows'),
        dots: product_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '0px',
              infinite: true
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
 
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('hide', 'fade');
      this.header.classList.remove('show');
    }

    reveal() {
      this.header.classList.add('fixed-top', 'fade', 'show');
      this.header.classList.remove('hide');
    }

    reset() {
      this.header.classList.remove('hide', 'fixed-top', 'show', 'fade');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
	$('.insta-feed').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 7,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  var content_grid_carousel = jQuery('.content-grid.carousel .row');
  var carousel_display = content_grid_carousel.data('slider-display');
  if(content_grid_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      content_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: content_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: content_grid_carousel.data('slider-arrows'),
        dots: content_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !Shopify.designMode) return;
  try {
    
if( window.innerWidth < 800 ) {
  var regEx = /&nbsp;/gm;
  var elements =  jQuery(".product-content .content .title").filter(function(index, ele) {
     if(regEx.test(jQuery(ele).html())) {
       jQuery(ele).empty();
    }
  });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  var product_grid_carousel = jQuery('.products.carousel .row');
  var product_grid_display = product_grid_carousel.data('slider-display');
  if(product_grid_carousel.length > 0 ) {
    if(product_grid_display == 'all' || ( product_grid_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      product_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: product_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: product_grid_carousel.data('slider-arrows'),
        dots: product_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
})();
